window.neptune.locationsearch = {
    init: function () {
        var x = document.querySelectorAll('.js-get-location');
        if (x.length == 0) {
            console.log("js class missing for geo locate")
            return;
        }
        if (navigator.geolocation == null) {
            console.log("geolocation not supported")
            return;
        }

        x.forEach(e => {
            e.addEventListener("click", c => {
                c.preventDefault();

                var options = {
                    enableHighAccuracy: true,
                    maximumAge: 30000,
                    timeout: 27000,
                }


                var success = (data) => {
                    var query = "latLng=" + data.coords.latitude + "," + data.coords.longitude;
                    var url = (Shopify.routes.root.length > 1 ? Shopify.routes.root : "/") + "pages/store-search-results?" + query;
                    window.location.href = url;
                }

                if (navigator.geolocation) {
                    navigator.geolocation.getCurrentPosition(success, () => { window.location.href = "/pages/store-search-results" }, options);
                }
                else {
                    error()
                }


            })
        })

    }
}